import type { ServiceRecord } from "../index";

export const service: ServiceRecord = {
  slug: "s1000d-conversion",
  kind: "domain-vertical",
  title: "S1000D Technical Publication Conversion",
  shortTitle: "S1000D Conversion",
  status: "ready",
  // `we-do`, not `experience`: the CV puts the S1000D-to-web conversion tool
  // under General Applications itself, and text.md §7 defines this tier as work
  // GA "can credibly design, build, improve, or guide today" rather than work
  // it has already invoiced. That makes the section heading "Current
  // Capability" and removes the prior-experience qualifier, which is only
  // required for work done before or outside GA.
  tier: "we-do",
  seoTitle: "S1000D XML Conversion & IETP Engineering | General Applications",
  seoDescription:
    "How S1000D data modules become usable web and offline technical publications: issue and BREX intake, reference resolution, applicability, and DMC-aware search.",
  summary:
    "Turning S1000D XML data modules into usable web and offline technical publications, with structured navigation, procedural interfaces, graphics, and search designed around the information model rather than flattened documents.",
  // PLACEHOLDER — borrowed from the military industry page so the hero frame
  // can be reviewed before any service art exists. Replace with
  // /images/services/s1000d-conversion-hero.webp (plus .avif and .png) before
  // this service is published.
  image: "/images/industries/military-hero.webp",
  relatedCapabilitySlugs: [],
  relatedIndustrySlugs: ["military"],
  relatedPostSlugs: [
    "s1000d-conversion-failure-modes",
    "s1000d-transform-loop",
    "reading-a-data-module-code",
    "s1000d-issue-archaeology",
    "shipping-s1000d-offline",
  ],
  // Built things, not sentences about building them. Each line names a
  // component a client could point at and ask for — which is the register a
  // service page needs, and reads far faster than task prose.
  //
  // Employer, program, client, and aircraft designation are all stripped per
  // services-strategy.md §4.3; what survives is the engineering.
  engineering: [
    "S1000D parsers and validators",
    "Publication models and reference-graph resolvers",
    "Aircraft 2D/3D equipment visualizers with part drill-down",
    "Procedural and smart form systems",
    "Hotspot-bound illustrated parts interfaces",
    "DMC-aware search indexes and facet models",
    "Offline publication packaging and update tooling",
    "Fleet installers for 10,000+ managed devices",
  ],
  phases: {
    study: {
      focus:
        "Inventory what is actually in the corpus before a parser is written.",
      produces: [
        "Corpus schema and BREX audit",
        "Graphics and hotspot inventory",
        "Applicability coverage model",
        "Search baseline and query analysis",
      ],
    },
    "initial-design": {
      focus:
        "Place the publication model between the parser and the delivery target.",
      produces: [
        "Intermediate publication data model",
        "DMC taxonomy and reference resolver",
        "Presentation boundary contract",
        "Applicability filtering schema",
      ],
    },
    "detailed-design": {
      focus:
        "Build the automated pipeline and the validation suites that prove it.",
      produces: [
        "S1000D parsing and validation engine",
        "Reference-graph resolution pipeline",
        "Hotspot and parts linkage system",
        "DMC search index and facet builder",
      ],
    },
    implementation: {
      focus:
        "Ship to standalone browser runtimes, offline distribution, or both.",
      produces: [
        "Browser IETP web application",
        "Deterministic offline packages",
        "Field update and rollback manifests",
        "Managed client device installers",
      ],
    },
  },
};
